import { ColumnProps } from 'antd/lib/table';
import { ConsultaImpuestos } from './Responses';
import { Tag } from 'antd';
import React from 'react';
import { RegistroImpuestosEstado } from './RegistroImpuestos';

export const ConsultasTableColumns: Array<ColumnProps<ConsultaImpuestos>> = [
    {
        title: 'Número',
        dataIndex: 'municipioClave',
        key: 'municipioClave',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) =>
            a.municipioClave - b.municipioClave
    },
    {
        title: 'Municipio',
        dataIndex: 'municipioNombre',
        key: 'municipioNombre',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.municipioNombre.length - b.municipioNombre.length
    },
    {
        title: 'Ejercicio',
        dataIndex: 'ejercicio',
        key: 'ejercicio',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.ejercicio - b.ejercicio
    },
    {
        title: 'Mes',
        dataIndex: 'mesString',
        key: 'mesString',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.mesString.length - b.mesString.length
    },
    {
        title: 'Tipo Recaudación',
        dataIndex: 'tipo',
        key: 'tipo',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.tipo.length - b.tipo.length
    },
    {
        title: 'Estatus',
        dataIndex: 'estatus',
        key: 'estatus',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.estatus.length - b.estatus.length,
        render: estatus => (
            <Tag color={
                estatus == 'Sin Captura' ? '#d9d9d9' :
                    estatus == 'Guardado' ? '#808080' :
                        estatus == 'Capturado' ? '#92D050' :
                            estatus == 'Rechazado' ? '#FF0000' :
                                estatus == 'Corregido' ? '#FFFF00' :
                                    '#00B050'
            } style={estatus == 'Corregido' ? { color: '#000', fontWeight: 'bold' } : { color: '#fff', fontWeight: 'bold' }} >
                {estatus}
            </Tag>

        ),
    },
    {
        title: 'Tipo Captura',
        dataIndex: 'captura',
        key: 'captura',
        sorter: (a: ConsultaImpuestos, b: ConsultaImpuestos) => a.captura.length - b.captura.length
    }
];
